import { RootfiIntegrationListItem } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { UseRootFiCompanyResult } from './types';

/**
 * A single RootFi connection with corporation, scope and invite-link data
 * (`GET rootfi/company/:id`).
 */
export function useRootFiCompany(
  rootFiCompanyId: number | null | undefined
): UseRootFiCompanyResult {
  const { data, error, mutate, isLoading } = useSWR<RootfiIntegrationListItem>(
    rootFiCompanyId
      ? `rootfi/company/${rootFiCompanyId}?include=corporation&include=scopeData&include=inviteLink`
      : null,
    async (url: string) =>
      SWRFetcher({ method: 'GET' })(url) as Promise<RootfiIntegrationListItem>
  );

  return { data, error, mutate, isLoading };
}
